<template>
    <div class="main">




        <v-row>
            <v-col cols="12" sm="6" md="4">

                <BasicDialog @close="closeClicked">
                    <v-row>


                        <v-col cols="12" class="d-flex flex-row justify-center align-center">
                            <logo-background></logo-background>
                            <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
                                <img :src="AppConfigs.staticImages.DAILYCHECKINDIALOG" alt="Share on Messenger"
                                    style="width: 70%; height: auto;">
                            </div>
                        </v-col>



                        <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
                          Daily Check-in
                        </v-col>



                        <v-col cols="12" class="text-center">
                          Click to claim your Reward!
                        </v-col>



                        <v-col cols="12" class="d-flex flex-row justify-center">
                            <v-btn rounded="pill"
                                :disabled="claimInProgress || !this.DailyCheckinDetails.availability_info.is_available"
                                class="  button--primary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex"
                                @click="claimCoins">
                                <template v-slot:prepend>
                                    <v-icon>
                                        <coin-big></coin-big>
                                    </v-icon>
                                </template>
                                + {{ dailyCheckinDetails.coins_amount }} Claim
                            </v-btn>
                        </v-col>


                    </v-row>
                </BasicDialog>

            </v-col>
        </v-row>




    </div>
</template>



<script>

import { AppConfigs } from "@/app.configs";
import { computed, inject, provide } from "vue";

import { useSnackbar } from '@/composables/useSnackbar';
import { UserActivityStore } from '@/store/UserActivityStore';

import CoinBig from "@/icons/CoinBig.vue";
import LogoBackground from "@/icons/LogoBackground.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";



export default {
    name: "DailyCheckinDialog",
    components: {
        CoinBig,
        BasicDialog,
        LogoBackground,
    },
    setup() {
        const inHouseTasksStore = UserActivityStore();
        let openDialog = inject('inHouseTaskOpenDialog');
        provide('openDialog', openDialog);

        const dailyCheckinDetails = computed(() => inHouseTasksStore.inHouseTasks['Daily Check-In']);
        const { showSnackbar } = useSnackbar();
        return { inHouseTasksStore, dailyCheckinDetails, showSnackbar, openDialog, AppConfigs };
    },
    data() {
        return {
            dialogOpenProp: this.dialogOpen,
            claimInProgress: false,
            claimingSnackbar: false,
            successSnackbar: false,
            errorSnackbar: false
        };
    },
    watch: {
        dialogOpen(newVal) {
            this.dialogOpenProp = newVal;
        },
    },
    computed: {
        DailyCheckinDetails() {
            return this.inHouseTasksStore.inHouseTasks['Daily Check-In'];
        }
    },
    methods: {
        async claimCoins() {
            if (!this.DailyCheckinDetails.availability_info.is_available)
                return;

            this.claimInProgress = true;

            this.showSnackbar({
                message: 'Claiming your reward.',
                color: 'info'
            });

            try {
                await UserActivityStore().claimDailyCheckin();

                this.showSnackbar({
                    message: 'Coins claimed successfully!',
                    color: 'success'
                });

                setTimeout(() => {
                    this.closeClicked();
                }, 1000);

            } catch (error) {

                this.showSnackbar({
                    message: 'Error claiming coins.',
                    color: 'error'
                });

                this.claimInProgress = false;
            }
            this.claimingSnackbar = false;
        },
        closeClicked() {
            this.$emit("close");
            this.openDialog = false;
        },
    },
};
</script>
